
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_62033_177)","fill":"#4A4A4A"}},[_c('path',{attrs:{"d":"M14.416 2.583l.077.004a.75.75 0 010 1.492l-.077.004H1.583a.75.75 0 110-1.5h12.833zM5.5 11.5V6.833a.75.75 0 011.5 0V11.5a.75.75 0 01-1.5 0zM9 11.5V6.833a.75.75 0 011.5 0V11.5a.75.75 0 01-1.5 0z"}}),_c('path',{attrs:{"d":"M14 14.416a1.335 1.335 0 01-1.333 1.334H3.333A1.334 1.334 0 012 14.416V3.333a.75.75 0 011.5 0V14.25h9V3.333a.75.75 0 011.5 0v11.083z"}}),_c('path',{attrs:{"d":"M10.166 3.333V2.167a.417.417 0 00-.335-.41l-.08-.007h-3.5a.417.417 0 00-.418.417v1.166a.75.75 0 01-1.5 0V2.167A1.917 1.917 0 016.25.25h3.5l.19.01a1.916 1.916 0 011.726 1.907v1.166a.75.75 0 01-1.5 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_62033_177"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    